export default {
      id: "kiosque_telecharger-usage",
      viewBox: "0 0 43 43",
      url: "../dist/images/" + "sprite.svg#kiosque_telecharger-usage",
      toString: function () {
        return this.url;
      }
    }